import { Container } from "typedi";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { namespace } from "vuex-class";
import { store } from "@/core/store";
import { LoginBody } from "@flosum-auth/contracts";
import { USER_LOCALSTORAGE_KEY } from "@/modules/auth/auth.constants";
// TODO: fix ASAP
// eslint-disable-next-line import/no-cycle
import { AuthService } from "@/modules/auth/services/auth.service";
import { AUTH_MODULE_NAMESPACE, AuthState } from "./auth.definitions";

@Module({
  name: AUTH_MODULE_NAMESPACE,
  namespaced: true,
  dynamic: true,
  store,
})
class AuthStore extends VuexModule {
  private readonly _authService: AuthService = Container.get(AuthService);

  public user: AuthState["user"] = null;

  public get isAuthenticated(): boolean {
    return !!this.user;
  }

  @Mutation
  public setUser(user: AuthState["user"]): void {
    this.user = user;
    window.localStorage.setItem(USER_LOCALSTORAGE_KEY, JSON.stringify(this.user));
  }

  @Action({ rawError: true })
  public async login(body: LoginBody): Promise<void> {
    await this._authService.login(body);
  }

  @Action({ commit: "setUser", rawError: true })
  public load(): AuthState["user"] {
    const userRaw = window.localStorage.getItem(USER_LOCALSTORAGE_KEY);

    if (!userRaw) {
      return null;
    }

    try {
      return JSON.parse(userRaw);
    } catch {
      return null;
    }
  }

  @Action({ commit: "setUser", rawError: true })
  public fetchSession(): Promise<AuthState["user"]> {
    return this._authService.fetchSession();
  }

  @Action({ commit: "setUser", rawError: true })
  public async logout(): Promise<null> {
    localStorage.removeItem(USER_LOCALSTORAGE_KEY);
    await this._authService.logout();
    return null;
  }
}

export const AuthStoreModule = getModule(AuthStore);
export const AuthStoreNamespace = namespace(AUTH_MODULE_NAMESPACE);
